export default __webpack_public_path__ + "static/media/photo-1548946526-f69e2424cf45.c592c0d0.jpeg";